const Stage = () => {
  const appEnv = import.meta.env.VITE_SENTRY_ENV;

  const envLabel =
    appEnv === "dev" ? "LOCAL" : appEnv === "staging" ? "STAGING" : null;

  if (!envLabel) return null; // Hide in production

  // Color palette depending on env
  const colorClass =
    envLabel === "LOCAL"
      ? "bg-red-500 text-white border-red-600"
      : "bg-yellow-300 text-yellow-900 border-yellow-400";

  return (
    <div
      className={`
          sticky bottom-0 z-20 w-full h-10 shrink-0
          flex items-center justify-center
          font-bold text-sm tracking-wide uppercase
          shadow-md border-t
          ${colorClass}
        `}
    >
      {envLabel === "LOCAL" && "🛠️ "}
      {envLabel === "STAGING" && "🚧 "}
      You are currently in {envLabel} mode
      {envLabel === "LOCAL" && " 🛠️"}
      {envLabel === "STAGING" && " 🚧"}
    </div>
  );
};

export default Stage;
